export default __webpack_public_path__ + "static/media/espaciodecoworking.44757771.svg";